import { GridContainer } from 'libs/ui';
import { Rfid } from 'grids/rfid/rfid';

export const RfidWrapper = (props) => {
  return (
    <GridContainer>
      <Rfid {...props} />
    </GridContainer>
  );
};
